"use client";

import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { CTACornerButton } from "@/shadcn/ui/corner-button";
import { PageTrademania2Schema } from "@/sanity/pages/PageTrademania2Template";

import logo from "@/public/trademania-2/nav-logo.svg";

export default function Header({ data }: { data: PageTrademania2Schema }) {
  const [dark, setDark] = useState(false);

  // glass over the hero video, darker once the light sections scroll underneath
  useEffect(() => {
    const onScroll = () => setDark(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const cta = data?.headerCTA ?? data?.heroCTA;

  return (
    <header
      className={cn(
        "fixed left-1/2 top-[1.5rem] z-50 flex h-[6.5rem] w-[calc(100%-4rem)] max-w-[180rem] -translate-x-1/2 items-center justify-between rounded-[12px] border border-white/10 py-[.75rem] pl-[1.25rem] pr-[.75rem] backdrop-blur-[20px] transition-colors duration-500 lg:top-[1.9rem] lg:h-auto lg:backdrop-blur-[111.5px]",
        dark ? "bg-[rgba(10,11,10,.55)]" : "bg-black/[.04]",
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={logo.src}
        alt="TradeMania"
        width={175}
        height={42.684}
        className="h-[4.375rem] w-auto lg:h-[5.336rem]"
      />

      <div className="flex items-center gap-[2.125rem]">
        {data?.headerLabel && (
          <span className="hidden items-center gap-[1rem] py-[1.5rem] lg:flex">
            <span className="flex rounded-full bg-[rgba(220,149,56,.2)] p-[.5rem]">
              <span className="h-[.875rem] w-[.875rem] animate-[tm2-pulse_1.6s_infinite] rounded-full bg-[#DC9538]" />
            </span>
            <span className="whitespace-nowrap font-geist text-[1.75rem] font-medium leading-[1.75rem] text-[#F4F4ED]">
              {data.headerLabel}
            </span>
          </span>
        )}
        <span className="hidden h-[4.375rem] w-px bg-white/20 lg:block" />
        {cta && <CTACornerButton data={cta} size="sm" mobileLabel={data?.headerCTAMobileLabel} />}
      </div>
    </header>
  );
}
